/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_CaptionInputs */

const cs_social_export_caption = /** @type {(inputs: Social_Export_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Popisek`)
};

const en_social_export_caption = /** @type {(inputs: Social_Export_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caption`)
};

/**
* | output |
* | --- |
* | "Caption" |
*
* @param {Social_Export_CaptionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_caption = /** @type {((inputs?: Social_Export_CaptionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_CaptionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_caption(inputs)
	return cs_social_export_caption(inputs)
});